module.exports = __webpack_public_path__ + "fonts/Freude.3a860734.otf";